import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { useDebounce } from 'ahooks'
import { Alert, Button, Select } from 'antd'
import { useTRPC } from '@/trpc/react.ts'

export function EnterpriseCustomerSelect({
  value,
  onChange,
  disabled,
  id
}: {
  value?: number
  onChange?: (value?: number) => void
  disabled?: boolean
  id?: string
}) {
  const trpc = useTRPC()
  const [keyword, setKeyword] = useState('')
  const query = useQuery(
    trpc.lookup.customers.queryOptions({ purpose: 'subject.read', keyword: useDebounce(keyword, { wait: 300 }) })
  )
  const selected = useQuery({
    ...trpc.lookup.customers.queryOptions({ purpose: 'subject.read', selectedId: value }),
    enabled: Boolean(value)
  })
  const options = [...(selected.data ?? []), ...(query.data ?? [])].filter(
    (row, index, rows) => rows.findIndex((other) => other.value === row.value) === index
  )
  return (
    <>
      <Select
        id={id}
        className="w-full"
        value={value}
        onChange={onChange}
        disabled={disabled}
        allowClear
        placeholder="搜索所属客户"
        loading={query.isFetching}
        options={options}
        showSearch={{ filterOption: false, onSearch: setKeyword }}
      />
      {query.isError && (
        <Alert
          className="mt-2"
          type="error"
          title={query.error.message}
          action={
            <Button size="small" onClick={() => void query.refetch()}>
              重试
            </Button>
          }
        />
      )}
    </>
  )
}
